export default {
    // 商城信息
    setShopInfo(state, shopInfo) {
        if (shopInfo === null) {
            state.shopInfo = null
            sessionStorage.removeItem('shopInfo')
        } else {
            sessionStorage.setItem('shopInfo', JSON.stringify(shopInfo))
            state.shopInfo = shopInfo
        }
    },
    // 商城信息
    setWechatAuth(state, wechatAuth) {
        if (wechatAuth === null) {
            state.wechatAuth = null
            sessionStorage.removeItem('wechatAuth')
        } else {
            sessionStorage.setItem('wechatAuth', JSON.stringify(wechatAuth))
            state.wechatAuth = wechatAuth
        }
    },
    // 用户信息
    setUserInfo(state, userInfo) {
        if (userInfo === null) {
            state.userInfo = {}
            localStorage.removeItem('userInfo')
        } else {
            const temp = Object.assign(state.userInfo, userInfo)
            localStorage.setItem('userInfo', JSON.stringify(temp))
            state.userInfo = temp
        }
    },

    // 微信用户头像、用户名
    setWxUserInfo(state, userInfo) {
        if (userInfo === null) {
            state.wxuserInfo = {}
            localStorage.removeItem('wxuserInfo')
        } else {
            const temp = Object.assign(state.wxuserInfo, userInfo)
            localStorage.setItem('wxuserInfo', JSON.stringify(temp))
            state.wxuserInfo = temp
        }
    },

    setToken(state, token) {
        if (token === null) {
            state.token = ''
            localStorage.removeItem('h5_access_token')
        } else {
            localStorage.setItem('h5_access_token', token)
            state.token = token
        }
    },
    setOpenid(state, openid) {
        if (openid === null) {
            state.openid = ''
            localStorage.removeItem('openid')
        } else {
            localStorage.setItem('openid', openid)
            state.openid = openid
        }
    }
}
